import styled from "styled-components";
import { useTranslation } from "react-i18next";

const CreditCardWrapper = styled.div`
  width: 432px;
  height: 64px;
  border-radius: 4px;
  border: 1px solid #404246;
  padding: 8px 12px;
`;
const CreditCardTitle = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  span {
    color: #bfc2c4;
    font-size: 12px;
    line-height: 17px;
  }
  .separator {
    margin: 0 4px;
  }
`;
const CreditCardValueWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  color: #d9dfe0;
  .symbol {
    font-size: 10px;
  }
  .credit {
    font-size: 24px;
    font-weight: 500;
    font-family: DINCond-Medium;
  }
`;
const GapLine = styled.div`
  width: 1px;
  height: 14px;
  background: rgba(255, 255, 255, 0.2);
  margin: 0 12px;
`;
export const CreditCard = ({
  currencySymbol,
  userCredit,
  totalCredit,
  isSubAccount,
}: {
  currencySymbol: string;
  userCredit: number;
  totalCredit?: number;
  isSubAccount: boolean;
}) => {
  const { t } = useTranslation("profile");

  return (
    <CreditCardWrapper>
      <CreditCardTitle>
        <span>{t("available_credit")}</span>
        {!isSubAccount && (
          <>
            <span className="separator"> / </span>
            <span>{t("user_total_credit")}</span>
          </>
        )}
      </CreditCardTitle>
      <CreditCardValueWrapper>
        <div>
          <span className="symbol">{currencySymbol}</span>
          <span className="credit">{userCredit}</span>
        </div>
        {!isSubAccount && (
          <>
            <GapLine />
            <div>
              <span className="symbol">{currencySymbol}</span>
              <span className="credit">{totalCredit ?? 0}</span>
            </div>
          </>
        )}
      </CreditCardValueWrapper>
    </CreditCardWrapper>
  );
};
